var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cellrenderer-linking-popularity-detail",style:(`color: ${_vm.params.value.color}; border-color:${_vm.params.value.color}; background-color:${_vm.params.value.color}10`)},[_vm._v(" "+_vm._s(_vm.params.value.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }